<ng-container *ngIf="isVisible">
  <div class="mb-3">
    <div class="btn-group">
      <button
        type="button"
        class="btn btn-sm btn-primary"
        [ngClass]="{active: qrMode == 1}"
        (click)="onToggleMode(1)"
      >
        myMedax-App
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        [ngClass]="{active: qrMode == 2}"
        (click)="onToggleMode(2)"
      >
        Browser
      </button>
    </div>
    <button
      type="button"
      class="btn btn-sm btn-sm btn-primary ml-1"
      (click)="onPrint()"
    >
      <i class="fa fa-print"></i>
    </button>
    <button
      type="button"
      class="btn btn-sm btn-sm btn-primary ml-1"
      (click)="onOpenWindow()"
    >
      <i class="fa fa-window-maximize"></i>
    </button>
  </div>

  <!-- Mobile App QR Code -->
  <ng-container *ngIf="qrMode == 1">
    <div class="qr-wrap">
      <img class="qr-inner" src="/assets/favicon/favicon-180x180.png" />
      <qrcode
        [qrdata]="mobileQrData"
        [margin]="0"
        [width]="256"
        [errorCorrectionLevel]="'M'"
      ></qrcode>
    </div>
    <br>
    <span class="txt-code">mymedax|patient|{{patientUid}}</span>
  </ng-container>

  <!-- Browser QR Code -->
  <ng-container *ngIf="qrMode == 2">
    <div class="qr-wrap">
      <div class="qr-inner">
        <i class="fa fa-globe"></i>
      </div>
      <qrcode
        [qrdata]="qrFillLink"
        [margin]="0"
        [width]="256"
        [errorCorrectionLevel]="'M'"
      ></qrcode>
    </div>
  </ng-container>
</ng-container>

